import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerPermisoRolUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/permiso-rol-usuario-web/obtener-permiso-rol-usuario-web",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.data = body;
        }
        return data;
    } catch (err) {
        console.log("obtenerPermisoRolUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function crearPermisoRolUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/permiso-rol-usuario-web/crear-permiso-rol-usuario-web",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearPermisoRolUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarPermisoRolUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/permiso-rol-usuario-web/actualizar-permiso-rol-usuario-web",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarPermisoRolUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}